// @flow

import React, { Component, Fragment } from 'react';
import type { RouteStagePointWithResult } from 'type/type';
import './RouteChart.scss';

type Props = {
  splitPoints: RouteStagePointWithResult[],
  isLive: boolean
}

const L_HEIGHT = 80;
const WIDTH = 16;

class RouteChart extends Component<Props> {
  static defaultProps = {
    splitPoints: [],
  }

  lineHeight: number

  isLive: boolean

  constructor(props: Props) {
    super(props);
    this.lineHeight = L_HEIGHT;
    this.isLive = props.isLive;
  }

  drawSplit(index: number) {
    return (
      <circle
        className="split"
        cx="8"
        cy={this.lineHeight * (index + 0.5) + 1}
        r={5}
        fill={this.isLive && index === 0 ? '#0070d9' : '#c2cbd1'} />
    );
  }

  drawStroke(index: number) {
    return (
      <line
        className="stroke"
        x1="8"
        x2="8"
        y1={this.lineHeight * (index + 0.65)}
        y2={this.lineHeight * (index + 1.35)}
        strokeDasharray="5 5"
        stroke={this.isLive && index === -1 ? '#0070d9' : '#c2cbd1'} />
    );
  }

  drawStart(index: number) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y={this.isLive ? this.lineHeight * (index + 0.5) - WIDTH * 0.5 : (this.lineHeight - WIDTH) * 0.5}
        width={WIDTH}
        height={WIDTH}
        viewBox="0 0 24 24"
        enableBackground="new 0 0 24 24"
        xmlSpace="preserve">
        <path
          className="start"
          d="M0,12C0,5.373,5.371,0,12,0c6.627,0,12,5.371,12,12c0,6.627-5.371,12-12,12C5.373,24,0,18.629,0,12z
        M6,12c0,3.307,2.687,6,6,6c3.307,0,6-2.687,6-6c0-3.307-2.687-6-6-6C8.693,6,6,8.687,6,12z" />
      </svg>
    );
  }

  drawFinish(index: number) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y={this.lineHeight * (index + 0.5) - WIDTH * 0.5}
        width={WIDTH}
        height={WIDTH}
        viewBox="0 0 24 24"
        enableBackground="new 0 0 24 24"
        xmlSpace="preserve">
        <path
          className="finish"
          d="M12,0C5.373,0,0,5.373,0,12c0,6.627,5.373,12,12,12c6.627,0,12-5.373,12-12C24,5.373,18.627,0,12,0z M18,13.5H8.25v4.992
        c0,0.557-0.455,1.008-0.994,1.008H6.994C6.445,19.5,6,19.051,6,18.492V5.507C6,4.951,6.455,4.5,6.994,4.5h0.263
        c0.549,0,0.994,0.449,0.994,1.007V6H18l-2.625,3.75L18,13.5z" />
      </svg>
    );
  }

  drawPoint(index: number) {
    switch (index) {
      case 0:
        return this.isLive ? this.drawSplit(index) : this.drawStart(index);
      case this.props.splitPoints.length - 1:
        return this.isLive ? this.drawStart(index) : this.drawFinish(index);
      default:
        return this.drawSplit(index);
    }
  }

  renderFinished(id: number, i: number, length: number) {
    return (
      <Fragment key={id}>
        { this.drawPoint(i) }
        { i < length - 1 ? this.drawStroke(i) : null }
      </Fragment>
    );
  }

  renderLive(id: number, i: number, length: number) {
    return (
      <Fragment key={id}>
        { i === 0 ? this.drawStroke(-1) : null }
        { this.drawPoint(i) }
        { i < length - 1 ? this.drawStroke(i) : null }
      </Fragment>
    );
  }

  render() {
    const { splitPoints } = this.props;
    const viewBoxHeight = this.lineHeight * splitPoints.length;
    return (
      <div className="participant-split-results-chart">
        <div className="wrapper">
          <svg
            className="chart"
            width={WIDTH}
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 ${WIDTH} ${viewBoxHeight}`}
            preserveAspectRatio="none">
            {
              splitPoints.map((sp, i) => (
                this.isLive
                  ? this.renderLive(sp.id, i, splitPoints.length)
                  : this.renderFinished(sp.id, i, splitPoints.length)
              ))
            }
          </svg>
        </div>
      </div>
    );
  }
}

export default RouteChart;
